// Format-Filter: gleichbedeutende Schreibweisen (MX = Maxi = MAXI, gf = GF) erscheinen als EIN Eintrag.
// Der Listen-Filter bekommt dann alle echten Schreibweisen per „|“ (Backend: format IN (...)).
// Aliase müssen mit api/src/lib/werkstoffGruppen.ts (FORMAT_ALIAS) übereinstimmen.
const ALIAS: Record<string, string> = { MX: 'MAXI', MAXI: 'MAXI' };

export interface FormatOption { key: string; label: string; roh: string[]; value: string }

export function formatOptionen(formate: string[]): FormatOption[] {
  const gruppen = new Map<string, string[]>();
  for (const f of formate) {
    const roh = f.trim().replace(/\s+/g, ' ');
    if (!roh) continue;
    const g = roh.toUpperCase();
    const key = ALIAS[g] ?? g;
    (gruppen.get(key) ?? gruppen.set(key, []).get(key)!).push(f);
  }
  return [...gruppen.entries()].map(([key, roh]) => {
    const label = ALIAS[key] ? key : (roh.find(r => r === r.toUpperCase()) ?? roh[0]!).trim();
    return { key, label, roh, value: roh.join('|') };
  });
}

// Welcher Eintrag ist für den aktuellen Filterwert (evtl. von Diagramm gesetzt) gewählt?
export function formatGewaehlt(optionen: FormatOption[], filter: string): string {
  if (!filter) return '';
  const teile = new Set(filter.split('|'));
  return optionen.find(o => o.roh.some(r => teile.has(r)))?.value ?? filter;
}
